import HeadBar from './head.vue';
import FootBar from './footer.vue';
import CommonPage from './common.vue'
import Ad  from './AdComponent.vue'
import Vue from 'vue';

Vue.component('HeadBar',HeadBar)
Vue.component('FootBar',FootBar)
Vue.component('CommonPage',CommonPage)
Vue.component('Ad',Ad)